/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Highlight_Next_EventInputs */



/**
* | output |
* | --- |
* | "Highlight Next Event" |
*
* @param {Shortcut_Keys_Name_Highlight_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_highlight_next_event = /** @type {((inputs?: Shortcut_Keys_Name_Highlight_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Highlight_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter l'evenement suivant a la selection")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nächstes Event hervorheben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Evidenzia il prossimo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выделите следующее событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Destacar el próximo evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("下一个活动亮点")
	if (locale === "ja") return /** @type {LocalizedString} */ ("次のイベントをハイライト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अगले कार्यक्रम को हाइलाइट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Destaque o próximo evento")
	return /** @type {LocalizedString} */ ("Highlight Next Event")
});